import { useMutation } from "@tanstack/react-query";

import { errorToast } from "@/shared/ui";
import { sendCancellationRequest } from "../api";

export const useSendCancellationRequest = () => {
  return useMutation({
    mutationFn: sendCancellationRequest,
    onError: errorToast,
  });
};
